export default __webpack_public_path__ + "a6f9156047b9b0a1ed5f9b42192ef4ff.png";